import { useRef, useContext } from 'react';
import { useDay } from '@datepicker-react/hooks';
import DatepickerContext from './datepickerContext';

function Day({ day, date }) {
  const dayRef = useRef(null);
  const {
    focusedDate,
    isDateFocused,
    isDateSelected,
    isDateHovered,
    isDateBlocked,
    isFirstOrLastSelectedDate,
    onDateSelect,
    onDateFocus,
    onDateHover
  } = useContext(DatepickerContext);
  const { isSelected, isSelectedStartOrEnd, onClick, onKeyDown, onMouseEnter, tabIndex } = useDay({
    date,
    focusedDate,
    isDateFocused,
    isDateSelected,
    isDateHovered,
    isDateBlocked,
    isFirstOrLastSelectedDate,
    onDateFocus,
    onDateSelect,
    onDateHover,
    dayRef
  });

  if (!day) {
    // eslint-disable-next-line jsx-a11y/control-has-associated-label
    return <button type="button" className="datepicker-day inactive" />;
  }

  return (
    <button
      className={`datepicker-day${isSelectedStartOrEnd ? ' selected' : ''}${
        isSelected ? ' range' : ''
      }`}
      onClick={onClick}
      onKeyDown={onKeyDown}
      onMouseEnter={onMouseEnter}
      tabIndex={tabIndex}
      disabled={isDateBlocked(date)}
      type="button"
      ref={dayRef}
    >
      {day}
    </button>
  );
}

export default Day;
